import { APIResponse } from "@definitions/api";
import { Auth } from "@definitions/auth";
import { Items } from "@definitions/items";
import { buildResponse, baseURL } from "@api/config";

export const synchronise = async (items:Items, auth:Auth):Promise<APIResponse> => {
  const headers = { "Content-Type": "application/json", "Authorization": auth.token || ""}
  try {
    const response = await fetch(`${baseURL}/items`, { method: "PATCH", headers, body: JSON.stringify({ items }) })

    if(response.status !== 200) {
      const { errors } = await response.json()
      return buildResponse({ success: false, errors })
    }
    const { data } = await response.json()

    return buildResponse({ success: true, data})
  } catch {
    return buildResponse({ success: false })
  }
}

export const poll = async (auth:Auth):Promise<APIResponse> => {
  const headers = { "Content-Type": "application/json", "Cache-Control": "max-age=5", "Authorization": auth.token || ""}
  try {
    const response = await fetch(`${baseURL}/items`, { method: "GET", headers })

    if(response.status !== 200 && response.status !== 304) {
      const { errors } = await response.json()
      return buildResponse({ success: false, errors })
    }
    const data = await response.json()

    return buildResponse({ success: true, data})
  } catch {
    return buildResponse({ success: false })
  }
}